<div class="tab-list">
  <h3 class="ff-title-xs ff-bold dsb-col-2">
    {{ 'documenti.DocumentiStr' | translate }}
  </h3>
  <ds-button
    style="margin-left: auto;
    width: auto;"
    *ngIf="!_idNonConformita"
    [attr.button-type]="'button'"
    [attr.reset-pair]="''"
    [attr.button-ui-variant]="'tertiary'"
    [attr.button-size]="'small'"
    [attr.button-label]="'Dashboard.VaiAiDocumentiStr' | translate"
    [attr.button-icon]="'icon-arrow-right'"
    [attr.is-disabled]="false"
    [attr.button-aria-label]="'Dashboard.VaiAiDocumentiStr' | translate"
    [attr.animation-play]="false"
    [attr.is-enable-activated]="false"
    [attr.has-aria-popup]="''"
    (onClickEvent)="goToDocumenti()"
    [attr.button-aria-controls]="''"
    [attr.button-aria-expanded]="''"></ds-button>
</div>

<div *ngIf="documentsDownloadComplete">
  <div *ngIf="!serverError; else errorBlock">
    <div *ngIf="erroreGestitoMex == null; else erroreGestitoBlock">
      <div *ngIf="documentiPresenti; else noDocumentiBlock">
        <div class="dsb-row" style="min-height: 150px">
          <div class="dsb-col-3" style="padding-bottom: 0px !important" *ngFor="let doc of documenti; index as i">
            <app-documents-card [documento]="doc"> </app-documents-card>
          </div>
        </div>
      </div>

      <ng-template #noDocumentiBlock>
        <app-no-element [isDocument]="true"></app-no-element>
      </ng-template>
    </div>
    <ng-template #erroreGestitoBlock>
      <div>
        <h3
          class="color-white"
          style="
            margin-bottom: 0px;
            display: inline-block;
            vertical-align: super;
          ">
          {{ erroreGestitoMex }}
        </h3>
      </div>
    </ng-template>
  </div>
  <ng-template #errorBlock>
    <div>
      <h3
        class="color-white"
        style="
          margin-bottom: 0px;
          display: inline-block;
          vertical-align: super;
        ">
        {{ 'ErroreImprevisto' | translate }}
      </h3>
    </div>
  </ng-template>
</div>

<ds-spinner
  *ngIf="!documentsDownloadComplete"
  [attr.spinner-ui-variant]="'spinner'"
  [attr.spinner-aria-label]="'Caricamento' | translate"></ds-spinner>
